import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { AuditFilterModel } from 'src/app/models/audit/audit-filter.model';
import { AuditService } from 'src/app/services/audit/audit.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss'],
  standalone: false
})
export class AuditComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filtersHeight: number = 0;
  filterObserver?: ResizeObserver;
  formAudit: FormGroup = new FormGroup({});
  listCompany: any[] = [];
  listProcess: CustomListDropdown[] = [{ label: 'Saldo Inventario - Saldo Alquiler', value: 1 }, { label: 'Remisión - Entrada Alquiler', value: 2 },
  { label: 'Entrada Alquiler - Remision', value: 3 }, { label: 'Devolución - Salidas Alquiler', value: 4 }, { label: 'Salidas Alquiler - Devolución', value: 5 },
  { label: 'Saldo Alquiler - Subalquiler', value: 6 }, { label: 'Saldo Alquiler. Saldo Final - Saldo Inicial ', value: 7 },
  { label: 'Saldo Inventario. Saldo Final - Saldo Inicial ', value: 8 }, { label: 'Saldo Cartera - Movimiento ', value: 9 },
  { label: 'Saldo Cartera. Saldo Final - Saldo Inicial ', value: 10 }];
  nameWindow: string = 'Revisión Saldos';
  projectName = ProjectName.projectName;

  constructor(private auditService: AuditService,
    private companyService: CompanyService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm();
  }

  ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.getCompanies();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight + 70 || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();
  }

  changeCompany(companyId: number | null) {
    if (companyId === 0 || companyId === null) {
      this.formAudit.controls["companyId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  clear() {
    this.changeFilter();
    this.validateForm();
  }

  async exportExcel() {
    if (this.changeFilters) {
      const modelRentalReportFilter = this.formAudit.value as AuditFilterModel;
      const dateInitial = this.formAudit.get("dateInitial")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);

      modelRentalReportFilter.period = Number(period);
      modelRentalReportFilter.year = Number(year);

      try {
        const response = await firstValueFrom(this.auditService.exportAuditRentalBalance(modelRentalReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe Auditoria.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast('info', 'No se encontraron datos para exportar.');
    }
  }

  async getCompanies() {
    try {
      this.listCompany = await firstValueFrom(this.companyService.getAllCompaniesForSelectAsync());
    } catch (error) {
      console.error('Error al buscar las compañías:', error);
    }
  }

  async send() {
    if (this.formAudit.valid) {
      const modelRentalReportFilter = this.formAudit.value as AuditFilterModel;
      //obtengo de Período
      const dateInitial = this.formAudit.get("dateInitial")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);

      modelRentalReportFilter.period = Number(period);
      modelRentalReportFilter.year = Number(year);

      try {
        this.dataReport = await firstValueFrom(this.auditService.auditRentalBalance(modelRentalReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      process: {
        required: 'El campo Proceso es obligatorio.',
        min: 'Debe seleccionar un Proceso válido.'
      },
      dateInitial: {
        required: 'El campo Período es obligatorio.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formAudit.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formAudit = this.formBuilder.group({
      process: [0, [Validators.required, Validators.min(1)]],
      dateInitial: ['', [Validators.required]],
      companyId: [0]
    });
  }

}
